import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Download, Menu, X } from "lucide-react";
import { LOGOS, NAV, PDF_FILENAME, PDF_URL } from "@/data/content";
import { scrollToId } from "@/lib/lenis";

const go = (e, id, after) => {
  e.preventDefault();
  scrollToId(id);
  if (after) after();
};

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-3 z-50 px-3 sm:top-5 sm:px-6"
      data-testid="main-navigation-bar"
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between rounded-full border-2 border-white/80 bg-white/70 py-2 pl-3 pr-2 shadow-[0_10px_40px_-15px_rgba(27,27,51,0.35)] backdrop-blur-xl">
        <a href="#topo" onClick={(e) => go(e, "#topo")} className="flex items-center gap-2" data-testid="nav-logo-link">
          <img src={LOGOS.show} alt="Pedro Clube Show" className="h-10 w-auto sm:h-11" />
        </a>
        <ul className="hidden items-center gap-1 lg:flex">
          {NAV.map((n) => (
            <li key={n.id}>
              <a
                href={n.id}
                onClick={(e) => go(e, n.id)}
                data-testid={`nav-link-${n.id.slice(1)}`}
                className="rounded-full px-4 py-2 text-sm font-semibold text-[var(--ink)] transition-colors duration-300 hover:bg-[var(--yellow)]/40"
              >
                {n.label}
              </a>
            </li>
          ))}
        </ul>
        <div className="flex items-center gap-2">
          <a
            href={PDF_URL}
            download={PDF_FILENAME}
            data-testid="nav-cta-download-pdf"
            className="group inline-flex items-center gap-2 rounded-full bg-[var(--red)] px-4 py-2.5 text-sm font-bold text-white transition-transform duration-300 hover:-translate-y-0.5 active:scale-95"
          >
            <Download className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            <span className="hidden sm:inline">Mídia Kit</span>
            <span className="sm:hidden">PDF</span>
          </a>
          <button
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
            data-testid="nav-mobile-menu-toggle"
            className="grid h-10 w-10 place-items-center rounded-full bg-[var(--ink)] text-white lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.ul
            initial={{ opacity: 0, y: -10, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.98 }}
            transition={{ duration: 0.25 }}
            className="mx-auto mt-2 max-w-6xl rounded-3xl border-2 border-white bg-white/95 p-3 shadow-xl backdrop-blur-xl lg:hidden"
            data-testid="nav-mobile-menu"
          >
            {NAV.map((n) => (
              <li key={n.id}>
                <a
                  href={n.id}
                  onClick={(e) => go(e, n.id, () => setOpen(false))}
                  data-testid={`nav-mobile-link-${n.id.slice(1)}`}
                  className="font-display block rounded-2xl px-4 py-3 text-2xl font-bold text-[var(--ink)] hover:bg-[var(--yellow)]/40"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
